export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8336.37e119fe.jpg";